// Sample content for the widgets whose content lives in the board config itself
// (officers, media, announcements, images, text). A template has these empty —
// the agency fills them in the designer — so a preview fills the empty ones
// with sample content and leaves anything the author already set alone.

const svgData = (svg) => "data:image/svg+xml;utf8," + encodeURIComponent(svg);

function poster(title, subtitle, from, to, glyph) {
  return svgData(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 900">
      <defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/></linearGradient></defs>
      <rect width="1600" height="900" fill="url(#g)"/>
      <circle cx="1320" cy="220" r="260" fill="#ffffff" opacity="0.07"/>
      <circle cx="1450" cy="720" r="180" fill="#ffffff" opacity="0.05"/>
      <text x="120" y="330" font-family="Arial, Helvetica, sans-serif" font-size="150" fill="#ffffff" opacity="0.9">${glyph}</text>
      <text x="120" y="520" font-family="Arial, Helvetica, sans-serif" font-weight="800" font-size="92" fill="#ffffff">${title}</text>
      <text x="120" y="610" font-family="Arial, Helvetica, sans-serif" font-size="46" fill="#ffffff" opacity="0.85">${subtitle}</text>
      <rect x="120" y="680" width="220" height="10" rx="5" fill="#ffffff" opacity="0.6"/>
    </svg>`
  );
}

const MEDIA = [
  { url: poster("Station 1 Open House", "Saturday 10 AM – 2 PM · Smoke trailer · Hose line for kids", "#7f1d1d", "#ea580c", "🚒"), type: "image", duration: 8 },
  { url: poster("Free Smoke Alarm Installs", "Call the station or sign up at the front desk", "#0f172a", "#2563eb", "🔔"), type: "image", duration: 8 },
  { url: poster("Welcome, Recruit Class 26", "Six new members graduated the academy this month", "#14532d", "#16a34a", "⭐"), type: "image", duration: 8 },
];

const LEADERSHIP = [
  { title: "Chief", name: "Robert Hale" },
  { title: "Deputy Chief", name: "Angela Moreno" },
  { title: "Assistant Chief", name: "Greg Tanaka" },
  { title: "Captain", name: "Marcus Bell" },
  { title: "Captain", name: "Priya Desai" },
  { title: "Lieutenant", name: "Dana Ortiz" },
];

const ANNOUNCEMENT = `
  <h2>Severe weather tonight</h2>
  <p>The Storm Prediction Center has the county under a <strong>Tornado Watch</strong> until 11 PM.</p>
  <ul>
    <li>Top off apparatus fuel and check chainsaws</li>
    <li>Recall list is posted by the watch desk</li>
    <li>Monitor the Storm Center board for warnings</li>
  </ul>
  <p><em>Stay safe and check in with the duty officer.</em></p>`;

// Thunderstorm icon for the sample weather, inline so previews need no network.
export const DEMO_WEATHER_ICON = svgData(
  `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
    <path d="M30 62a18 18 0 1 1 6-35 22 22 0 0 1 41 6 15 15 0 0 1-2 29z" fill="#cbd5e1"/>
    <path d="M52 58l-12 20h10l-6 16 18-24H51l7-12z" fill="#facc15"/>
  </svg>`
);

const IMAGE = poster("Riverside Fire Rescue", "Proudly serving since 1952", "#1e293b", "#7f1d1d", "🛡");

// The designer seeds new widgets with these placeholders (admin dashboard
// WIDGET_CATALOG defaultConfig); a preview treats them as empty.
const plainText = (html) => String(html || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
const PLACEHOLDER_HTML = ["", "Announcement Edit me…", "Announcement Edit me..."];
const PLACEHOLDER_TEXT = ["", "Text"];

function fill(widget) {
  const cfg = { ...(widget.config || {}) };
  switch (widget.type) {
    case "leadership":
      if (!Array.isArray(cfg.leadership) || cfg.leadership.length === 0) cfg.leadership = LEADERSHIP;
      break;
    case "mediaRotation":
      if (!Array.isArray(cfg.items) || cfg.items.length === 0) cfg.items = MEDIA;
      break;
    case "announcements":
      if (PLACEHOLDER_HTML.includes(plainText(cfg.html))) cfg.html = ANNOUNCEMENT;
      break;
    case "image":
      if (!cfg.url) cfg.url = IMAGE;
      break;
    case "textBlock":
      if (PLACEHOLDER_TEXT.includes(String(cfg.text || "").trim())) cfg.text = "Welcome to Station 1";
      break;
    default:
      return widget;
  }
  return { ...widget, config: cfg };
}

export function withDemoContent(config) {
  if (!config) return config;
  return {
    ...config,
    screens: (config.screens || []).map((s) => ({ ...s, widgets: (s.widgets || []).map(fill) })),
  };
}
